import React, { Component } from 'react';

import APIDocsCurl from 'common/developers/docs/api/APIDocsCurl';
import APIDocsMethod from 'common/developers/docs/api/APIDocsMethod';
import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsListIdeasBlock extends Component {
  createdAt = new Date();

  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">List ideas</div>
          <div className="text">
            Returns a list of ideas. Include parameters to specify pagination, filtering, and
            sorting.
          </div>
          <APIDocsTable
            title="Arguments"
            rows={[
              {
                heading: 'apiKey',
                subheading: 'string',
                description: 'Your secret API key.',
              },
              {
                heading: 'cursor',
                subheading: 'string (optional)',
                description:
                  'A pagination cursor returned from a previous request. Used to fetch the next page of results.',
              },
              {
                heading: 'filtering',
                subheading: 'Filtering object (optional)',
                description:
                  'A filtering object containing filters and filtersOperator. Filters allow you to filter ideas by various fields such as author, group, owner, status, etc. The filtersOperator can be "all" (AND) or "any" (OR).',
              },
              {
                heading: 'limit',
                subheading: 'number (optional)',
                description:
                  "The number of ideas you'd like to fetch. Defaults to 50 if not specified. Maximum is 100.",
              },
              {
                heading: 'parentID',
                subheading: 'string (optional)',
                description:
                  'If specified, will only fetch ideas that are children of the idea with this id.',
              },
              {
                heading: 'search',
                subheading: 'string (optional)',
                description:
                  'If specified, will only fetch ideas that match your search query. Note: search does not support pagination or sorting.',
              },
              {
                heading: 'sort',
                subheading: 'object (optional)',
                description:
                  'An object specifying how to sort the ideas. Must have "field" (string) and "direction" ("asc" or "desc") properties. Defaults to { field: "_id", direction: "desc" } if not specified.',
              },
            ]}
          />
          <div className="subheading">Returns</div>
          <div className="text">
            A dictionary with an "items" property that contains an array of idea objects. There's
            also a "hasNextPage" property that specifies whether this query returns more ideas than
            the limit, and a "cursor" property that can be used to fetch the next page of results
            when hasNextPage is true.
          </div>
        </div>
        <div>
          <div className="text">Endpoint</div>
          <Highlight lang="http">https://canny.io/api/v1/ideas/list</Highlight>
          <APIDocsMethod />
          <APIDocsCurl
            path="https://canny.io/api/v1/ideas/list"
            body={`\\
    -d apiKey=YOUR_API_KEY \\
    -d limit=10`}
          />
          <div className="text">Example Response</div>
          <Highlight lang="json">
            {`{
  "cursor": "eyJhZnRlciI6eyJfaWQiOiI1NTNjM2VmOGI4Y2RjZD...",
  "hasNextPage": true,
  "items": [{
    "id": "553c3ef8b8cdcd1501ba1238",
    "author": {
      "id": "553c3ef8b8cdcd1501ba1236",
      "created": "${this.createdAt.toISOString()}",
      "email": "jane@example.com",
      "isAdmin": false,
      "name": "Jane Doe",
      "url": "https://your-company.canny.io/admin/users/jane-doe",
      "userID": "5678"
    },
    "childCount": 1,
    "created": "${this.createdAt.toISOString()}",
    "description": "Test idea description",
    "group": {
      "id": "553c3ef8b8cdcd1501ba1235",
      "name": "Feature Requests",
      "description": "Feature requests are ideas for new features or improvements to the product.",
      "urlName": "feature-requests"
    },
    "owner": {
      "id": "553c3ef8b8cdcd1501ba1236",
      "created": "${this.createdAt.toISOString()}",
      "email": "john@example.com",
      "isAdmin": false,
      "name": "John Doe",
      "url": "https://your-company.canny.io/admin/users/john-doe",
      "userID": "1234"
    },
    "parent": {
      "id": "553c3ef8b8cdcd1501ba1237",
      "title": "Parent Idea",
      "urlName": "parent-idea"
    },
    "source": {
      "name": "canny",
      "type": "web"
    },
    "status": {
      "id": "553c3ef8b8cdcd1501ba2234",
      "name": "Under Review",
      "type": "Active",
      "urlName": "under-review"
    },
    "title": "An awesome feature request",
    "updatedAt": "${this.createdAt.toISOString()}",
    "urlName": "an-awesome-feature-request"
  }]
}`}
          </Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
